import { useQueryClient as n, useMutation as r } from "@tanstack/vue-query";
import { blacklistAutoRuleKeys as l } from "./queries.js";
const y = (c, u) => {
  const s = n(), t = u?.onSuccess;
  return r({
    ...u,
    mutationFn: async (e) => c.blacklistAutoRule.create(e.body),
    onSuccess: async (...e) => {
      await s.invalidateQueries({ queryKey: l.all }), t && t(...e);
    }
  });
}, d = (c, u) => {
  const s = n(), t = u?.onSuccess;
  return r({
    ...u,
    mutationFn: async (e) => c.blacklistAutoRule.update({ ruleId: e.ruleId, ...e.body }),
    onSuccess: async (...e) => {
      await s.invalidateQueries({ queryKey: l.all }), t && t(...e);
    }
  });
}, m = (c, u) => {
  const s = n(), t = u?.onSuccess;
  return r({
    ...u,
    mutationFn: async (e) => c.blacklistAutoRule.remove({ ruleId: e.ruleId }),
    onSuccess: async (...e) => {
      const [, a] = e;
      s.removeQueries({ queryKey: l.detail(a.ruleId) }), await s.invalidateQueries({ queryKey: l.all }), t && t(...e);
    }
  });
};
export {
  y as useCreateBlacklistAutoRule,
  m as useDeleteBlacklistAutoRule,
  d as useUpdateBlacklistAutoRule
};
//# sourceMappingURL=mutations.js.map
